export default __webpack_public_path__ + "static/redline-logo-gray-89c2b4d25294b88cc2c925371d0df19b.png";